import React from "react";


class ShopInfo extends React.Component {
    render() {
        return (
            <div className="general-info-wrap">
                <div className="general-info-img"/>
                <h1 className="title-one">APPLIANCES</h1>
                <p className="title-two">Online Shop</p>
                <div className="short-title-wrap">
                    <p className="short-title">We offer the sale of goods of all categories. Low prices. Always in
                        stock.</p>
                </div>
                <p className="title-all-products">PRODUCTS</p>
            </div>
        );
    }
}

export default ShopInfo